<template>
    <div>
        <TipTap
            v-if="!is_walkthrough"
            v-model="question.content.question"
            :menu_items="[]"
            :readonly="true"
        />
        <div :class="{'merlin-asset-border': isMerlinMedia}">
            <div v-if="isMerlinMedia" class="merlin-asset-wrapper">
                <span class="merlin-asset-warning">
                    <font-awesome-icon :icon="['fas', 'exclamation-triangle']" fixed-width />
                    Merlin Asset
                </span>
            </div>

            <img
                v-if="question.content.media.type == 'image'"
                style="max-height: 300px; width: auto; max-width: 300px;"
                :src="question.content.media.src"
            />
            <video
                v-if="question.content.media.type == 'video'"
                width="100%"
                :poster="question.content.media.splash_url"
                controls
            >
                <source :src="question.content.media.src">
                Your browser does not support the video tag.
            </video>
            <audio
                v-if="question.content.media.type == 'audio'"
                controls
            >
                <source :src="question.content.media.src">
                Your browser does not support the audio tag.
            </audio>
            <div
                v-if="question.content.media.type == 'sims'"
            >
                <b-card>
                    <template v-slot:header>
                        <div class="d-flex">
                            <div>Sim: {{ question.content.media.title }}</div>
                            <div class="ml-auto">
                                <b-btn
                                    :variant="!playSim ? 'success' : 'danger'"
                                    @click="playSim = !playSim"
                                    v-tippy="{placement: 'top'}"
                                    :content="playSim ? 'Stop Sim': 'Play Sim'"
                                >
                                    <font-awesome-icon v-if="!playSim" :icon="['fas', 'play']" fixed-width />
                                    <font-awesome-icon v-else :icon="['fas', 'stop']" fixed-width />
                                </b-btn>
                                <b-btn
                                    class="ml-2"
                                    variant="outline-primary"
                                    :href="question.content.media.src"
                                    target="_blank"
                                    v-tippy="{placement: 'top'}"
                                    content="Open in new tab"
                                >
                                    <font-awesome-icon
                                        :icon="['fad', 'external-link']"
                                        fixed-width
                                    />
                                </b-btn>
                            </div>
                        </div>
                    </template>
                    <iframe
                        v-if="playSim" :src="question.content.media.src"
                        class="w-100"
                    />
                    <div v-else>
                        <img
                            v-if="question.content.media.splash_url"
                            style="max-height: 300px; width: auto; max-width: 300px;"
                            :src="question.content.media.splash_url"
                        />
                        <div>Use the Play Button to load this sim.</div>
                    </div>
                </b-card>

            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>
export default {
    data: () => ({
        playSim: false,
    }),
    props: [
        'question',
        'question_html',
        'is_walkthrough',
    ],
    components: {
        TipTap: () => import('@/components/tiptap/TipTap')
    },
    computed: {
        isMerlinMedia() {
            const questionHasContent = this.question && this.question.content
            const questionContentHasImage = this.question.content.media && this.question.content.media.src
            if (!questionHasContent || !questionContentHasImage) {
                return false
            }
            return this.question.content.media.src.toLowerCase().includes('merlinone')
        },
    }
}
</script>
